"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearPromotionFormToJSON = exports.ClearPromotionFormFromJSONTyped = exports.ClearPromotionFormFromJSON = void 0;
const runtime_1 = require("../runtime");
function ClearPromotionFormFromJSON(json) {
    return ClearPromotionFormFromJSONTyped(json, false);
}
exports.ClearPromotionFormFromJSON = ClearPromotionFormFromJSON;
function ClearPromotionFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !runtime_1.exists(json, 'email') ? undefined : json['email'],
    };
}
exports.ClearPromotionFormFromJSONTyped = ClearPromotionFormFromJSONTyped;
function ClearPromotionFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
    };
}
exports.ClearPromotionFormToJSON = ClearPromotionFormToJSON;
//# sourceMappingURL=ClearPromotionForm.js.map